import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@/contexts/UserContext';
import Header from '@/components/ui/Header';
import JobCard from './components/JobCard';
import FilterPanel from './components/FilterPanel';
import JobStats from './components/JobStats';
import { LoadingState, EmptyState } from './components/LoadingState';
import Pagination from './components/Pagination';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';
import apiRequest from "@/services/requests";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const JobMatching = () => {
const navigate = useNavigate();
const { user } = useUser();
const [jobs, setJobs] = useState([]);
const [isLoading, setIsLoading] = useState(true);
const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);
const [totalResults, setTotalResults] = useState(0);
const [stats, setStats] = useState({totalMatches:0, appliedToday:0, responseRate:0});
const resultsPerPage = 10;
const [filters, setFilters] = useState({
keywords: '',
location: 'any',
radius: '25',
salaryMin: 0,
salaryMax: 200000,
experienceLevel: 'any',
industry: 'any',
jobType: 'any'
});



const redirectTo = (link) =>{
navigate(link); 
return;
} 

const loadDashboard = async () => {
setIsLoading(true);
try {
const [jobData, statData] = await Promise.all([
apiRequest.getMatching({ page: currentPage, perPage: 10, ...filters }),
apiRequest.matchingStats()          // add this helper once (see below)
]);
setJobs(jobData.jobs);
setTotalResults(jobData.totalResults);
setTotalPages(jobData.totalPages);
setStats(statData.stats);       // real numbers
} catch (e) {
console.error(e);
toast.error('Could not load records, please refresh page or try again later',{
position:'bottom-left'
});
} finally {
setIsLoading(false);
}
};


useEffect(() => { loadDashboard(); }, [currentPage, filters]);

const handleFiltersChange = (newFilters) => {
setFilters(newFilters);
setCurrentPage(1);
};

const handleClearFilters = () => {
setFilters({
keywords: '',
location: 'any',
radius: '25',
salaryMin: 0,
salaryMax: 200000,
experienceLevel: 'any',
industry: 'any',
jobType: 'any'
});
setCurrentPage(1);
};


const deleteJobPost = async (jobId) => {
await apiRequest.matchingDelete(jobId);
toast.success('Job removed from queue', { position: 'bottom-left' });
loadDashboard(); // refresh list
};




const handlePageChange = (page) => {
setCurrentPage(page);
window.scrollTo({ top: 0, behavior: 'smooth' });
};

const hasActiveFilters = () => {
return filters?.keywords || 
(filters?.location && filters?.location !== 'any') ||
filters?.salaryMin > 0 ||
filters?.salaryMax < 200000 ||
(filters?.experienceLevel && filters?.experienceLevel !== 'any') ||
(filters?.industry && filters?.industry !== 'any') ||
(filters?.jobType && filters?.jobType !== 'any');
};





return (
<div className="min-h-screen bg-background">
<Header />
<main className="pt-16">
<div className="max-w-7xl mx-auto px-6 py-8">
{/* Page Header */}
<div className="mb-8">
<div className="flex items-center justify-between mb-4">
<div>
<h1 className="text-xl lg:text-3xl font-bold text-text-primary mb-2">Job Matching</h1>
<p className="text-text-secondary text-sm">
Discover AI-powered job matching your profile
</p>
</div>

<div className="hidden md:flex items-center space-x-3">
<Button
variant="outline"
iconName="RefreshCw"
iconPosition="left"
iconSize={16}
onClick={loadDashboard}
disabled={isLoading}
>
Refresh
</Button>

<Button
variant="default"
iconName="Settings"
iconPosition="left"
iconSize={16}
onClick={()=>navigate('/settings',{
state:{
section:'preferences'
}
})}
>
Preferences
</Button>
</div>
</div>

{/* Job Stats */}
<JobStats 
stats={ stats} 
autoApply={user?.account.auto_apply_enabled} />
</div>

 

{/* Job Listings */}
<div className="space-y-4">
{isLoading ? (
<LoadingState />
) : jobs?.length === 0 ? (
<EmptyState 
hasFilters={hasActiveFilters()} 
onClearFilters={handleClearFilters}
/>
) : (
<>
{jobs?.map(job => (
<JobCard
key={job?.id}
job={job}
onDelete={deleteJobPost}
redirectTo={redirectTo}
/>
))}

{/* Pagination */}
<Pagination
currentPage={currentPage}
totalPages={totalPages}
totalResults={totalResults}
resultsPerPage={resultsPerPage}
onPageChange={handlePageChange}
isLoading={isLoading}
/>
</>
)}
</div> 

{/* Mobile Action Buttons */}
<div className="md:hidden fixed bottom-16 right-6 flex flex-col space-y-3">
<Button
variant="default"
size="icon"
className="w-10 h-10 rounded-full shadow-elevation-2"
onClick={loadDashboard}
disabled={isLoading}
>
<Icon name="RefreshCw" size={20} />
</Button>

</div>
</div>
</main>
</div>
);
};
 
export default JobMatching;